/**
 * Comprueba si un archivo cumple el atributo `accept` del input (extensiones o MIME).
 *
 * @param accept Lista separada por comas, p. ej. `.png,.jpg,.pdf` o `image/png,image/jpeg`.
 */
export function fileMatchesAccept(file: File, accept: string): boolean {
  const tokens = accept
    .split(',')
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  if (tokens.length === 0) return true;

  const name = file.name.toLowerCase();
  const mime = file.type.toLowerCase();

  return tokens.some((token) => {
    if (token.startsWith('.')) {
      return name.endsWith(token);
    }
    if (token.includes('/')) {
      if (token.endsWith('/*')) {
        const prefix = token.slice(0, -1);
        return mime.startsWith(prefix);
      }
      return mime === token;
    }
    return false;
  });
}
